import { IconLogout } from '@tabler/icons-react';
import type { IconProps } from '@tabler/icons-react';
import type { ComponentType } from 'react';

export interface NavigationItem {
	icon: ComponentType<IconProps>;
	label: string;
	description: string;
	path: string;
	badge?: string;
}

export const LEFT_COLUMN_ITEMS: NavigationItem[] = [];

export const LOGOUT_ITEM = {
	icon: IconLogout,
	label: 'Log out',
	description: '',
	isLogout: true,
};
